module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/019-ceuta-62a32c54133c9714a718f0a893b40ae0.svg";